import React from 'react'
import { Asset } from 'src/types'

import './MapAssets.sass'
import { useMap, useMapLastPosition, useMapMarkers, useMapSelf } from './useMap'

interface MapAssetsProps {
  assets: Asset[]
  center?: 'user' | 'assets' | 'all'
}

const MapAssets = ({ assets = [], center }: MapAssetsProps) => {

  const theMap = useMap('map-assets')
  useMapMarkers(theMap, assets, center === 'assets')
  useMapSelf(theMap, center === 'user')
  useMapLastPosition(theMap)

  return <div id="map-assets" />
}

export default MapAssets
